import type { PackageDTO } from '@brainkey/shared';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';

import { publicApi } from '../api/endpoints';
import { queryKeys } from '../queryClient';

/** The public package catalog (marketing pricing page, "Contact Us"
 * package picker) — no auth required, already sorted by `tier`. */
export function usePackages(): UseQueryResult<PackageDTO[]> {
  return useQuery({
    queryKey: queryKeys.packages.list,
    queryFn: async ({ signal }) => (await publicApi.listPackages(signal)).packages,
    staleTime: 5 * 60_000,
  });
}
